import { render } from "./CustomInputText.vue?vue&type=template&id=f5388c34"
import script from "./CustomInputText.vue?vue&type=script&lang=js"
export * from "./CustomInputText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__